import React from 'react';
import { compose } from 'ramda';
import {
  reduxForm,
  InjectedFormProps,
  Form,
  formValueSelector,
} from 'redux-form';
import Button from '@material-ui/core/Button';
import FormHelperText from '@material-ui/core/FormHelperText';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import WizardCard from 'components/WizardCard/WizardCard';
import Fields from 'components/Fields';
import StoreProvider from 'components/StoreProvider/StoreProvider';
import { PreviousStepType } from 'components/Wizard/Wizard';
import IntlProvider, { useFormatMessage } from 'components/IntlProvider';

import { validate, wizardStyles } from './wizardUtils';

const { connect } = StoreProvider;

interface ProductAudienceAgeProps extends PreviousStepType {
  audienceAge: [number, number];
}

const ProductAudienceAge = ({
  handleSubmit,
  error,
  audienceAge,
  previousStep,
}: ProductAudienceAgeProps & InjectedFormProps) => {
  const classes = wizardStyles();
  const t = useFormatMessage();
  return (
    <WizardCard>
      <Form onSubmit={handleSubmit} className={classes.form} noValidate>
        <Grid item xs={12}>
          <Typography
            component="h1"
            variant="h5"
            color="inherit"
            className={classes.title}
          >
            {t(
              'forms.wizard.productaudienceage',
              'For which target persons would you like to test your product?'
            )}
          </Typography>
          <Fields.Wizard.Age audienceAge={audienceAge} />
          {error && <FormHelperText error>{error}</FormHelperText>}
          <Button
            classes={{
              root: classes.submitButton,
            }}
            type="submit"
            variant="contained"
            color="primary"
          >
            {t('fields.wizard.common.continue', 'Continue')}
          </Button>
          <Button
            onClick={previousStep}
            classes={{
              root: classes.secondaryButton,
            }}
            color="secondary"
          >
            {t('fields.wizard.common.back', 'Back')}
          </Button>
        </Grid>
      </Form>
    </WizardCard>
  );
};

const selector = formValueSelector('wizard');

export default compose(
  IntlProvider.withIntl,
  connect((state) => ({
    audienceAge: selector(state, 'audience_age'),
  })),
  reduxForm({
    form: 'wizard',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    validate,
  })
)(ProductAudienceAge);
